import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'next/router'
import Link from 'next/link'
import styled from 'styled-components'
import { trackElementPageView } from '../../store/actions'

const StyledDiv = styled.div`
  display: flex;
  color: ${props => (props.isSelected ? props.theme.colors.green1 : props.theme.colors.black1)};
  font-weight: ${props => (props.isSelected ? 600 : 400)};
  justify-content: flex-start;
  text-align: left;
  padding-left: 15px;
  font-size: 0.9em;
  margin: 3px;
  &:hover {
    font-weight: bold;
    cursor: pointer;
  }
`
class Element extends Component {
  render() {
    return (
      <Link
        href={`/explore/element?elementId=${this.props.elementId}`}
        as={`/explore/element/${this.props.elementId}`}
      >
        <StyledDiv
          isSelected={
            this.props.elementId !== null && this.props.elementId === this.props.selectedElementId
          }
        >
          <span>{this.props.name}</span>
        </StyledDiv>
      </Link>
    )
  }
}

export default connect()(withRouter(Element))
